module.exports = __webpack_public_path__ + "assets/img/36_508_big.e1082dd0.jpg";